import React from 'react'
import { Box, Typography } from '@material-ui/core'
import AccentBox from 'src/components/PostGraduationContent/PostgraduateComponents/AccentBox/AccentBox'
import { useGlobalStyles } from 'src/mui/styles/globalStyles'
import { useStyles } from './SubscriptionSuccess.styles'

const SubscriptionSuccess = () => {
  const classes = useStyles()
  const globalClasses = useGlobalStyles()

  return (
    <>
      <Typography variant="h3" className={globalClasses.titleSectionVariant2}>
        Formulário de inscrição enviado.
      </Typography>
      <Typography className={classes.successText}>
        Seu formulário foi enviado com sucesso!
      </Typography>
      <Typography className={classes.description}>
        Obrigado por se inscrever na Residência em Segurança Cibernética.
        <br />A divulgação do resultado e da lista de selecionados ocorrerá no
        dia 29 de abril de 2022.
      </Typography>
      <Box className={classes.separator} />
      <Typography variant="h3" className={globalClasses.titleSectionVariant2}>
        Contato
      </Typography>
      <AccentBox email="rsc@lsbd.ufc.br" />
    </>
  )
}

export default SubscriptionSuccess
